// import { Api, auth } from '@/service';

import * as forge from 'node-forge'
import { Switch as cSwitch } from '@coreui/vue';
import logLoginList from '../../Log/login/login.Admin.List.i18n'
import speakeasy from 'speakeasy';
import QRCode from 'qrcode';
import reg from '@/reg'
import * as _ from 'lodash';

//restful api
import { auth } from '@/service/api/_api'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: ''
});

const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'username', label: 'User', sortable: false },
    { key: 'addr', label: 'ADDR', sortable: false },
    { key: 'created_at', label: 'Date', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'username', label: '사용자명', sortable: false },
    { key: 'addr', label: '주소', sortable: false },
    { key: 'created_at', label: '날짜', sortable: false },
  ]
}

export default {
  components: { cSwitch, QRCode, logLoginList },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  data : () => ({
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
    otp_changed : false,
    origin : '',url : '', value: '', urlurl : '', toggleOtp : false,
    size: 300, qrcode : '',so : default_opt(), confirm: false, add: false, lock: true, group_list: undefined, model : { group: {} }, log : {}}),
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n]
    },
  },
  methods: {
    password_policy(type = '')
    {
      // new_password == next_password
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.next_password && reg.reg_number.test(this.model.next_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.next_password && reg.reg_alphabat_upper.test(this.model.next_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.next_password && reg.reg_alphabat_lower.test(this.model.next_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.next_password && reg.reg_spacial.test(this.model.next_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.next_password && this.model.next_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    async genOtp(){
      if(!this.toggleOtp || this.qrcode) { this.model.otp_pin = undefined; return this.$toastr.w("Applies when saved.", "Press Save!"); }
      if(this.model.is_otp) { console.log("not generate QRcode"); return this.$toastr.w("Applies when saved.", "Press Save!"); }
      try {
        // let key = (await Api.auth.otpGen({})).otpkey;
        let key = (await auth.otpGen({})).otpkey;
        let address = speakeasy.otpauthURL({ issuser : 'f1security', encoding: 'base32', digits : 6, period : 30, algorithm : 'sha1', secret: key, label: `F1-UWSS:Manager:${this.model.username}`});
        this.qrcode = await QRCode.toDataURL(encodeURI(address))
        this.model.otpkey = key;
        this.$toastr.w("Applies when saved.", "Press Save!");
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    async registerOtp(m){
      try {
        if(!m.otp_pin) { return this.$toastr.e('OTP code', 'Require'); }
        // { otp_key : "", otp_pin : "", password : "" }
        // let rs = await Api.auth.otpRegister(m)
        let rs = await auth.otpRegister(m)
        if(!rs) { return this.$toastr.w('failed', 'update') }
        this.$toastr.s('registed OTP done!', 'update')
        this.cancel();
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    async unregisterOtp(m){
      try {
        // { password : '' }
        // let rs = await Api.auth.otpUnregister(m)
        let rs = await auth.otpUnregister(m)
        if(rs) {
          this.$toastr.s('unregisted OTP done!', 'update')
        } else {
          this.$toastr.e('unregisted OTP failed!', 'update')
        }
        this.cancel();

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    // getItems: function(ctx) { return this.get(ctx); },
    cancel() { this.qrcode = ""; this.$router.replace({ name: 'profile' }); },
    edit() { this.$router.push({ name: 'profile', params: { tag: 'edit' }}); },
    async save() {
      console.log(this.$route)
      if(!this.model.now_password) { return this.$toastr.e('Now Password', 'Require')}
      // if(this.model.username != auth.profile.username && !(this.model.new_password || '').length) { return this.$toastr.e('Password is required when changing email (ID).'); }
      if(!this.model.id && !this.model.next_password) { return this.$toastr.e('password repeat', 'Require'); }
      if(this.model.next_password && this.model.next_password != this.model.new_password_repeat) { return this.$toastr.e('Password repeat not match', 'Require'); }
      if(this.model.next_password) { this.model.new_password = forge.sha256.create().update(this.model.next_password).digest().toHex(); }
      if(!this.toggleOtp) { this.model.otpkey = undefined; }

      try {
        this.model.password = forge.sha256.create().update(this.model.now_password).digest().toHex();
        if(this.model.new_password && location.hostname != "localhost") {
          var rs_policy = this.password_policy('all')
          if(rs_policy.is_error) {
            var msg = rs_policy.key.indexOf('is') > -1 ? rs_policy.key.substring(3) : rs_policy.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }

        if(this.model.is_otp) {
          // 사용중으로 삭제할 경우
          if(this.model.is_otp != this.toggleOtp && this.toggleOtp == false) {
            await this.unregisterOtp({ password : this.model.password });
            return console.log("Profile OTP Unregisted");

          }
        } else {
          // 미사용으로 등록할 경우
          if(this.toggleOtp && this.model.otp_pin) {
            await this.registerOtp({ username : this.model.username, password : this.model.password, otp_key : this.model.otpkey, otp_pin : this.model.otp_pin });
            return console.log("Profile OTP Registed");
          }
        }

        // let rs = await Api.auth.update(Object.assign({}, this.model));
        let rs = await auth.update(Object.assign({}, this.model));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.lock = true;
          this.get(this.$route.params.id);
        } else {
          this.$toastr.e('Saved', "failed");
        }
        this.cancel();
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.lock = false; }

    },
    async get({ id, tag } = this.$route.params) {
      console.log('profile.detail.vue', 'load item', id);
      delete this.model.next_password;
      delete this.model.new_password_repeat;
      this.add = false;
      this.lock = (tag !== 'edit');

      try {
        // this.model = await Api.auth.profile(auth.profile.id);
        this.model = await auth.profile(auth.profile.id);
        this.model.is_otp = this.model.otpkey && this.model.otpkey.length ? true : false
        this.toggleOtp = this.model.is_otp;

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) ; this.cancel(); }
    },
  },
  created() { console.log('profile.detail.vue', 'created'); },
  destroyed() { console.log('profile.detail.vue', 'destroyed'); },
  mounted() { console.log('profile.detail.vue', 'mounted'); this.get(this.$route.params);  },
}